// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  CODEVERSION: '20251028-2',
  SERVER_TZ_OFFSET: 10800,
  WS_API: {
    HOST: location.host.includes('win-line.ru')?location.host:location.host.replace('.','-wss.'),
    PATH: '/api',
    PROTOCOL: 'wss'
  },
  SIP: {
    HOST: location.host.includes('win-line.ru')?location.host:location.host.replace('.','-wss.'),
    PATH: '/sip',
    PROTOCOL: 'wss',
    ECHO_NUMBER: '79999999999'
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts